<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Solicitud de Inscripción</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="4" lg="3" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <ListadoDetallesSolicitudesInscripciones
              ref="listadoRef"
              :items="item.detallesSolicitudesInscripciones"
              :cargando="false"
              rowSelection="single" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn
          v-if="
            visibleBotonAprobar &&
            item.estado == estadosSolicitudesInscripciones.PENDIENTE &&
            permisosAcademicosNacional
          "
          color="primary"
          text
          @click.prevent="$refs.modalFormularioAprobarSolicitudInscripcionRef.abrir(item)">
          Aprobar
        </v-btn>

        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>

      <ModalFormularioAprobarSolicitudInscripcion
        ref="modalFormularioAprobarSolicitudInscripcionRef"
        @cerrar="cerrarActualizar" />
    </v-card>
  </v-dialog>
</template>

<script>
import { ESTADOS_SOLICITUDES_INSCRIPCIONES } from '../utils/constantes';
import ListadoDetallesSolicitudesInscripciones from './ListadoDetallesSolicitudesInscripciones.vue';
import ListadoItem from './ListadoItem.vue';
import ModalFormularioAprobarSolicitudInscripcion from './ModalFormularioAprobarSolicitudInscripcion.vue';
import { mapGetters } from 'vuex';
import { concatenar, imprimirModulo, obtenerModuloMasAlto } from '../utils/funciones';

export default {
  name: 'ModalMostrarSolicitudInscripcion',
  components: {
    ListadoDetallesSolicitudesInscripciones,
    ListadoItem,
    ModalFormularioAprobarSolicitudInscripcion,
  },
  props: {
    visibleBotonAprobar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      item: this.generarObjetoFormRegistrar(),
      nombreItem: 'Solicitud de Inscripción',
      estadosSolicitudesInscripciones: ESTADOS_SOLICITUDES_INSCRIPCIONES,
    };
  },
  computed: {
    numeroEstudiantes() {
      return this.item.detallesSolicitudesInscripciones.length;
    },
    listado() {
      return [
        { nombre: 'N° Solicitud', valor: this.item.numeroSolicitud },
        { nombre: 'Fecha Solicitud', valor: this.item.fechaSolicitud },
        { nombre: 'N° Estudiantes', valor: this.numeroEstudiantes },
        { nombre: 'Estado', valor: this.item?.estado?.toUpperCase() },
        { nombre: 'Programa (Código)', valor: this.item.programa?.codigo },
        { nombre: 'Programa (Nombre Compuesto)', valor: this.item.programa?.nombreCompuesto },
        { nombre: 'Sede', valor: this.item?.sede?.nombre || '-' },
        {
          nombre: 'Módulo Actual',
          valor: this.programaModuloTexto,
        },
        {
          nombre: 'Código Prog. Univ. | Nombre Prog. Univ.',
          valor:
            concatenar(
              this.item.programa?.programaUniversidad?.codigo,
              ' | ',
              this.item.programa?.programaUniversidad?.programaNombre,
            ) || '-',
        },
        { nombre: 'Solicitado por', valor: this.item.nombreSolicitante },
        { nombre: 'Atendido por', valor: this.item.atendidoPor || '-' },
        { nombre: 'Fecha Atención', valor: this.item.fechaAtencion || '-' },
      ];
    },
    ...mapGetters({
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
    }),
    programaModuloMasAlto() {
      const programasModulos = this.item?.programa?.programasModulos;

      return obtenerModuloMasAlto(programasModulos);
    },
    programaModuloTexto() {
      return imprimirModulo(this.programaModuloMasAlto);
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        programaId: null,
        programa: null,
        sedeId: null,
        sede: null,
        programaUniversidadId: null,
        programaUniversidad: null,
        numeroSolicitud: null,
        fechaSolicitud: null,
        estado: null,
        solicitanteId: null,
        nombreSolicitante: null,
        atendidoPor: null,
        fechaAtencion: null,
        creadoEn: null,
        actualizadoEn: null,
        detallesSolicitudesInscripciones: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        programaId: data.programaId,
        programa: data.programa,
        sedeId: data.sedeId,
        sede: data.sede,
        programaUniversidadId: data.programaUniversidadId,
        programaUniversidad: data.programaUniversidad,
        numeroSolicitud: data.numeroSolicitud,
        fechaSolicitud: data.fechaSolicitud,
        estado: data.estado,
        solicitanteId: data.solicitanteId,
        nombreSolicitante: data.nombreSolicitante,
        atendidoPor: data.atendidoPor,
        fechaAtencion: data.fechaAtencion,
        creadoEn: data.creadoEn,
        actualizadoEn: data.actualizadoEn,
        programasModulos: data.programasModulos || [],
        detallesSolicitudesInscripciones: data.detallesSolicitudesInscripciones
          .sort(
            (a, b) =>
              a.inscripcion.estudiante?.primerApellido?.localeCompare(b.inscripcion.estudiante?.primerApellido) ||
              a.inscripcion.estudiante?.segundoApellido?.localeCompare(b.inscripcion.estudiante?.segundoApellido) ||
              a.inscripcion.estudiante?.nombres?.localeCompare(b.inscripcion.estudiante?.nombres),
          )
          .map((detalleInscripcion) => {
            const { inscripcion } = detalleInscripcion;

            return {
              id: detalleInscripcion.id,
              inscripcionId: inscripcion.id,
              estado: detalleInscripcion.estado,
              estudiante: inscripcion.estudiante,
              estadoAcademico: inscripcion.estadoAcademico,
              creadoEn: detalleInscripcion.creadoEn,
              actualizadoEn: detalleInscripcion.actualizadoEn,
            };
          }),
      };
    },
    abrir(data = null) {
      this.item = this.generarObjetoFormEditar(data);
      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
    cerrarActualizar() {
      this.cerrar();
      this.$emit('cerrar');
    },
  },
};
</script>